import flatten from 'lodash/flatten';

import DEFAULT_EVENT_PROPERTY_MAP from 'common/onboarding/immersive-onboarding/default-events-properties.json';
import {IndustryKey} from 'common/onboarding/immersive-onboarding/types';

export const getDefaultEventList = (industry: IndustryKey): string[] => {
  return DEFAULT_EVENT_PROPERTY_MAP[industry].default_events.map((event) => event.name);
};

export const getMapFromDictionary = (eventsPropertiesMap: {[key: string]: string[]}) => {
  return new Map(Object.keys(eventsPropertiesMap).map((event) => [event, eventsPropertiesMap[event] ?? []]));
};

export const getDefaultEventPropertiesMap = (industry: IndustryKey, events?: string[]): Map<string, string[]> => {
  const defaultEvents = DEFAULT_EVENT_PROPERTY_MAP[industry].default_events;

  return new Map(
    (events ?? getDefaultEventList(industry)).map((event) => {
      const eventAsDefault = defaultEvents.filter((defaultEvent) => defaultEvent.name === event)?.[0];
      return [eventAsDefault?.name ?? event, eventAsDefault?.properties.map((prop) => prop.name) ?? []];
    }),
  );
};

export const getDefaultProperties = (industry: IndustryKey, event: string): {[key: string]: string[]} => {
  if (!industry) {
    return {};
  }

  return (
    DEFAULT_EVENT_PROPERTY_MAP[industry].default_events.filter((defaultEvent) => defaultEvent.name === event)?.[0]
      ?.properties ??
    DEFAULT_EVENT_PROPERTY_MAP[`b2b`].default_events.filter((defaultEvent) => defaultEvent.name === `Sign Up`)[0]
      .properties
  ).reduce((acc: {[key: string]: string[]}, prop) => {
    acc[prop.name] = prop.breakdowns;
    return acc;
  }, {});
};

export const getBreakdownValues = (property: string) => {
  const properties = flatten(
    Object.keys(DEFAULT_EVENT_PROPERTY_MAP).flatMap((key) => {
      return DEFAULT_EVENT_PROPERTY_MAP[key].default_events.map((event) => event.properties);
    }),
  );

  return (
    properties.filter((defaultProperty) => defaultProperty.name === property)[0]?.breakdowns ?? [
      `Property A`,
      `Property B`,
      `Property C`,
    ]
  );
};

export const inputValidator = (val) => {
  return val.trim().length > 0;
};
